import { FC } from 'react';

import { Flex, Form } from 'antd';
import classNames from 'classnames';

import CheckboxFormItem from '@/components/form/form-items/default-items/checkbox-form-item/CheckboxFormItem';

import styles from './DebtsInstructions.module.scss';

export const DebtsInstructions: FC = () => {
	const form = Form.useFormInstance();

	const businessDebtsValue = Form.useWatch('businessDebts', form) || [];

	return (
		<Flex className={styles['container']} gap={10} vertical>
			<span className={classNames(styles['text'], styles['title'])}>Instructions</span>
			<div className={styles['body']}>
				<span className={classNames(styles['text'], styles['text-body'])}>
					To be completed by applicant. Please list all outstanding debts of the business and
					provide all requested information.
				</span>
				<div className={styles['checkbox-row']}>
					<CheckboxFormItem
						className={styles['checkbox']}
						disabled={businessDebtsValue.length > 0}
						name="noOutstandingDebts"
						required={false}
					>
						<span className={classNames(styles['text'], styles['checkbox-text'])}>
							If your <b>business has no outstanding debts</b>, please check this box, then sign and
							submit below.
						</span>
					</CheckboxFormItem>
				</div>
			</div>
		</Flex>
	);
};
